import * as Lucide from "lucide-react";
import { SERVICES } from "@/lib/data";

const ServicesGrid = ({ compact = false }) => {
  const items = compact ? SERVICES.slice(0, 6) : SERVICES;

  return (
    <section className="py-24 lg:py-32 bg-sand" data-testid="services-section">
      <div className="container-tm">
        <div className="max-w-3xl mb-16">
          <span className="overline">Nos services</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Une offre complète pour faciliter
            <span className="italic text-gold"> la location de votre bien</span>.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {items.map((s, i) => {
            const Icon = Lucide[s.icon] || Lucide.Sparkles;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group card-modern p-7 lg:p-8 flex flex-col"
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-sage/10 flex items-center justify-center group-hover:bg-sage transition-colors duration-500">
                    <Icon size={22} strokeWidth={1.6} className="text-sage group-hover:text-white transition-colors duration-500" />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.25em] font-semibold text-gold">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif text-2xl text-ink mb-3 leading-tight">{s.title}</h3>
                <p className="font-sans text-sm text-ink/65 leading-relaxed flex-1">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
